import { loadOrderInvoiceBilling } from './orderInvoiceBilling';
import { mapUserProfileToBilling } from './mapUserProfileToBilling';
import { getCurrentUserProfile } from './profileCache';

/**
 * @typedef {import('./orderInvoiceBilling').OrderInvoiceBilling} OrderInvoiceBilling
 */

/**
 * Resolves checkout billing defaults for logged-in users.
 * Priority: session billing for this order, then authenticated profile, then empty fields.
 * Forces a fresh profile fetch so a previous session cache cannot prefill another buyer's email.
 *
 * @param {string | null | undefined} orderId
 * @returns {Promise<Partial<OrderInvoiceBilling>>}
 */
export async function resolveCheckoutBillingInitialValues(orderId) {
  const savedBilling = loadOrderInvoiceBilling(orderId);
  if (savedBilling) {
    return savedBilling;
  }

  let profile = null;
  try {
    profile = await getCurrentUserProfile({ force: true });
  } catch (error) {
    console.error('[resolveCheckoutBillingInitialValues] Failed to load profile:', error);
  }

  return mapUserProfileToBilling(profile);
}
